import {
    useCallback, useMemo,
} from 'react'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import {
    RichTableData,
} from 'app/types/richtable.types'
import {
    SelectedContainer,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import useLabel from 'app/hooks/useLabel'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'

import getColumns from './BookedContainers.columns'
import useStyles from './BookedContainers.styles'

type Props = {
    value?: SelectedContainer[],
}

const defaultProps: Partial<Props> = {
    value: [],
}

const BookedContainers = ({
    value,
}: Props) => {
    const {
        classes,
    } = useStyles()
    const l = useLabel()
    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const onRowClick = useCallback(({
        serialNumber,
    }) => {
        ContainersRoutes.SensorData.navigate({
            params: {
                key: serialNumber,
            },
        })
    }, [ContainersRoutes])

    const load = useCallback((): Promise<RichTableData<SelectedContainer[]>> => {
        return Promise.resolve({
            data: value,
        })
    }, [value])

    const columns = useMemo(() => {
        return getColumns({
            l,
        })
    }, [l])

    return (
        <RichTable
            configName="SelectedAssets"
            name="SelectedContainers"
            columns={columns}
            load={load}
            className={classes.tableContent}
            classNames={{
                contentWrapper: classes.tableContentWrapper,
            }}
            rowStyle={{
                crossLine: 'isRejected',
            }}
            onRowClick={onRowClick}
        />
    )
}

BookedContainers.defaultProps = defaultProps

export default BookedContainers
